import React from 'react';
import StoreCardList from '../../../components/store/StoreCardList';
import StoreListStyle from '../../../assets/stylesheets/store/StoreList.module.css';

export default function StoreList({ title = 'Items', items = [], loading = false, showDiscountBadge = false }) {
  return (
    <section className={StoreListStyle['store-list-section']}>
      <div className={StoreListStyle['store-list-header']}>
        <h1 className={StoreListStyle['store-list-title']}>{title}</h1>
        <div className={StoreListStyle['store-list-count']}>{items?.length ?? 0} items</div>
      </div>

      <div>
        <StoreCardList
          items={items}
          loading={loading}
          skeletonCount={items?.length || 12}
          showDiscountBadge={showDiscountBadge}
          layout="grid"
          gridGap={20}
          gridMinWidth={260}
          onBuy={(item) => {
            // placeholder action for demo
            // eslint-disable-next-line no-console
            console.log('Buy clicked:', item);
          }}
        />
      </div>
    </section>
  );
}
